module.exports = __webpack_public_path__ + "static/media/wicket4.0bea4699.png";